
import { authSupabaseClient } from '@/integrations/supabase/authClient';
import { sendPhoneOtp as sendOtp, verifyPhoneOtp as verifyOtp } from '../courierQueries';
import { formatPhoneToE164 } from './phoneUtils';

// Переэкспортируем функции из courierQueries
export { formatPhoneToE164 };

// Отправка OTP на телефон
export const sendPhoneOtp = async (phone: string) => {
  return sendOtp(phone);
};

// Проверка OTP
export const verifyPhoneOtp = async (phone: string, token: string) => {
  return verifyOtp(phone, token);
};

// Функции для email авторизации
export const signInWithEmail = async (email: string, password: string) => {
  try {
    const { data, error } = await authSupabaseClient.auth.signInWithPassword({
      email,
      password
    });
    
    return { data, error };
  } catch (error: any) {
    console.error('Ошибка входа по email:', error);
    return { data: null, error };
  }
};

export const signUpWithEmail = async (
  email: string, 
  password: string,
  userData?: { name?: string; role?: string }
) => {
  try {
    const { data, error } = await authSupabaseClient.auth.signUp({
      email,
      password,
      options: {
        data: userData
      }
    });
    
    return { data, error };
  } catch (error: any) {
    console.error('Ошибка регистрации по email:', error);
    return { data: null, error };
  }
};

// Сброс пароля
export const resetPassword = async (email: string) => {
  try {
    const { data, error } = await authSupabaseClient.auth.resetPasswordForEmail(
      email,
      {
        redirectTo: `${window.location.origin}/reset-password`,
      }
    );
    
    return { data, error };
  } catch (error: any) {
    console.error('Ошибка сброса пароля:', error);
    return { data: null, error };
  }
};

// Обновление пароля
export const updatePassword = async (newPassword: string) => {
  try {
    const { data, error } = await authSupabaseClient.auth.updateUser({
      password: newPassword
    });
    
    return { data, error };
  } catch (error: any) {
    console.error('Ошибка обновления пароля:', error);
    return { data: null, error };
  }
};
